import React from "react";
import PropTypes from "prop-types";
import { TabsWrapper } from "./style";

export default function Tabs({ tabData = [], activeTab, setActiveTab }) {

  const activeTabClick =(tab, index) =>{
  
    setActiveTab(tab)
  }

  return (
    <TabsWrapper>
      {tabData.length >= 0 &&
        tabData.map((data, i) => (
          <button
            disabled={data.active}
           // style={{ opacity: !data.active ? 0.5 : 1 }}
            key={data.id}
            className={activeTab === data.id ? "active" : ""}
            onClick={()=>activeTabClick(data.id,i)}
          >
            {data.name}
          </button>
        ))}
    </TabsWrapper>
  );
}

Tabs.propTypes = {
  activeTab: PropTypes.number,
  setActiveTab: PropTypes.func,
  tabData: PropTypes.String,
};
